export default __webpack_public_path__ + "assets/images/ccd09728cba1f1675a4e4c13c8ea4c17.png";